import { Debug } from "@sc07-canvas/lib/debug";
import {
  type ModClientToServerEvents,
  type ModServerToClientEvents,
} from "@sc07-canvas/lib/net";
import { io, Socket } from "socket.io-client";

export class ModeratorModule {
  private static instance: ModeratorModule;
  socket: Socket<ModServerToClientEvents, ModClientToServerEvents> = io(
    "/mod",
    { autoConnect: false },
  );

  private constructor() {
    Debug.controllers.set("Moderator", this);

    this.socket.on("connect", () => {
      console.log("connected to mod socket");
    });

    this.socket.on("connect_error", (err) => {
      if (this.socket.active) {
        console.log("disconnected temporarily");
      } else {
        console.log("failed to connect", err);
      }
    });

    this.socket.on("disconnect", () => {
      console.log("disconnected");
    });

    this.socket.on("captcha", (...data) => {
      console.log(...data);
    });
  }

  static get() {
    if (!this.instance) this.instance = new ModeratorModule();
    return this.instance;
  }

  connect() {
    this.socket.connect();
  }
}
